import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Extract the shared typography classes into a single constant
const TYPOGRAPHY_CLASSES = [
  "display-1-bold",
  "display-1-medium",
  "display-1-regular",
  "display-2-bold",
  "display-2-medium",
  "display-2-regular",
  "title-1-bold",
  "title-1-medium",
  "title-1-regular",
  "title-2-bold",
  "title-2-medium",
  "title-2-regular",
  "title-3-bold",
  "title-3-medium",
  "title-3-regular",
  "heading-1-semibold",
  "heading-1-medium",
  "heading-1-regular",
  "heading-2-semibold",
  "heading-2-medium",
  "heading-2-regular",
  "headline-1-semibold",
  "headline-1-medium",
  "headline-1-regular",
  "headline-2-semibold",
  "headline-2-medium",
  "headline-2-regular",
  "body-1-normal-semibold",
  "body-1-normal-medium",
  "body-1-normal-regular",
  "body-1-reading-semibold",
  "body-1-reading-medium",
  "body-1-reading-regular",
  "body-2-normal-semibold",
  "body-2-normal-medium",
  "body-2-normal-regular",
  "body-2-reading-semibold",
  "body-2-reading-medium",
  "body-2-reading-regular",
  "label-1-normal-semibold",
  "label-1-normal-medium",
  "label-1-normal-regular",
  "label-1-reading-semibold",
  "label-1-reading-medium",
  "label-1-reading-regular",
  "label-2-semibold",
  "label-2-medium",
  "label-2-regular",
  "caption-1-semibold",
  "caption-1-medium",
  "caption-1-regular",
  "caption-2-semibold",
  "caption-2-medium",
  "caption-2-regular",
];

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": TYPOGRAPHY_CLASSES,
      "font-weight": TYPOGRAPHY_CLASSES,
      leading: TYPOGRAPHY_CLASSES,
      tracking: TYPOGRAPHY_CLASSES,
      shadow: ["button-focus", "input-focus", "input-error"],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}
